export const localDateStringToInstant = (dateTime: string | Date): string => {
  return new Date(dateTime).toISOString();
};

export const unixToLocalDateString = (tsSeconds: number | string): string => {
  const d = new Date(Number(tsSeconds) * 1000);

  const yyyy = d.getFullYear();
  const MM = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const HH = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');

  return `${yyyy}-${MM}-${dd}T${HH}:${mm}`;
};
